import { SmileOutlined } from "@ant-design/icons";
import { Button, Popover } from "antd";
import { Picker } from "emoji-mart";
import { useCallback } from "react";
// eslint-disable-next-line import/order
import "emoji-mart/css/emoji-mart.css";

type Props = {
  disabled: boolean;
  iconClassname?: string;
  onSelect: (emoji: string) => void;
};

export const EmojiInput: React.FC<Props> = ({
  disabled,
  iconClassname,
  onSelect,
}) => {
  const addEmoji = useCallback(
    (emoji: string) => {
      onSelect(emoji);
    },
    [onSelect],
  );

  return (
    <Popover
      content={
        <Picker
          native
          // @ts-expect-error -- incorrect types
          onSelect={(data) => addEmoji(data.native)}
          sheetSize={16}
          emojiSize={16}
          showSkinTones={false}
          showPreview={false}
        />
      }
      overlayClassName="p-0"
      trigger="click"
    >
      <Button
        type="link"
        size="large"
        className="emoji-picker-btn"
        disabled={disabled}
        icon={<SmileOutlined className={iconClassname} />}
      />
    </Popover>
  );
};
